export interface PhoneLoginFormValues {
    mobileNumber: string;
    password: string;
}

export const phoneLoginValues: PhoneLoginFormValues = {
    mobileNumber: '',
    password: ''
};
